export default __webpack_public_path__ + "f123cef8827b6e10d59d5abab357d1ab.png";